import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useDispatch, useSelector } from "react-redux";
//import
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import InstructionBlock from './InstructionBlock/InstructionBlock';
import { getQuestionLocation } from "examsbook-react-sdk/selectors";
import { setActiveQuestionIndex, saveQuizResponse } from "examsbook-react-sdk/actions";
import QuestionPlayground from "./QuestionPlayground";
import HeaderSidebar from "./HeaderSidebar";
import { useTranslations, useWindowSize } from "examsbook-react-sdk/custom-hooks";
import { getQuizStatus } from "examsbook-react-sdk/common";
import ExclamationIcon from './../../assets/images/finish-icon.PNG';
//import css
import 'react-confirm-alert/src/react-confirm-alert.css';

/**
 * QuizPlayground component.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizPlayground(props) {
    const t = useTranslations();
    const { quizMode, viewMode, isLoading, quiz, totalQuestions, slug } = props;
    const questions = useSelector(state => state.quiz.questions);
    const activeQuestionIndex = useSelector(state => state.activeQuestionIndex);
    const questionLocationHead = useSelector(state => getQuestionLocation(state));
    const dispatch = useDispatch();
    const [ toggleClass, setToggleClass ] = useState('');
    const [ showInstructionBox, setInstructionBox ] = useState(true);
    const [ quizIsStarted, setQuizStarted ] = useState(false);
    const [ isDrawerClosed, setDrawerToggle ] = useState(false);
    const [ changeSectionActive, setActiveSection ] = useState(questionLocationHead.sectionNo || 0);
    const currentRef = useRef(0);
    const windowSize = useWindowSize();
    const [ isFullscreen, setFullScreen ] = useState(false);
    const [ pauseQuiz, setPauseQuiz ] = useState(false);
    const [ ModelOpen, setModelOpen ] = useState(false);
    const classes = useStyles();
    const { answered, marked, notAnswered, notAnsweredVisited } = getQuizStatus(quiz.questions);

    useEffect(() => {
        if (windowSize.width <= 767) {
            setDrawerToggle(true);
        } else {
            setDrawerToggle(false);
        }
    }, [ windowSize ]);

    function handleFullScreen() {
        setFullScreen(!isFullscreen);
    }

    /**
     * Select question on question palette click
     * @param questionIndex
     */
    function selectPaletteQuestion(questionIndex) {
        dispatch(setActiveQuestionIndex(questionIndex));
        saveQuizResponseFn(false);
        setToggleClass('');
    }

    /**
     * toggle instructions.
     */
    function toggleInstructionBox() {
        setInstructionBox(!showInstructionBox);
    }

    // start quiz.
    function startQuiz() {
        setQuizStarted(true);
        setInstructionBox(false);
    }

    //global function to set time taken. it get stored in db while submission.
    function setTimeTakenFn(timeTaken) {
        currentRef.current = timeTaken;
    }

    function toggleClick() {
        setToggleClass(toggleClass === '' ? 'toggled' : '');
    }

    function toggleDrawerHandler() {
        setDrawerToggle(!isDrawerClosed);
    }

    function submitQuiz() {
        saveQuizResponseFn(true);
    }

    function handleQuizPauseChange(value) {
        setPauseQuiz(value);
        setModelOpen(value);
    }

    /**
     *
     * @param type
     * Desc: handle next and prev navigation from footer
     */
    async function handleClickOnQuestionNavigator(type) {
        if (questions && questions.length) {
            if ((questionLocationHead.questionNo + 1) === questions[questionLocationHead.sectionNo].questions.length) {
                setActiveSection(questionLocationHead.sectionNo + 1);
            }
        }
        if (type === 'next') {
            if (totalQuestions - 1 > activeQuestionIndex) {
                dispatch(setActiveQuestionIndex(activeQuestionIndex + 1));
            } else if (!viewMode) {
                //it is last question, promt user to submit quiz

                confirmAlert({
                    closeOnClickOutside: true,
                    overlayClassName: "overlay-custom-class-name",
                    customUI: ({ onClose }) => {
                        return (<div className={classes.paper}>
                            <img src={ExclamationIcon} alt=""/>
                            <h2>{t('Are_you_sure_you_want_to_finish')}</h2>
                            <span>{t('FINISH_MODAL_DESC')}</span>
                            <div className={classes.quizQuestionList}>
                                <ul>
                                    <li>
                                        <span className={classes.attempted}/>
                                        <p>{t('attempted')}</p>
                                        <h4>{answered}</h4>
                                    </li>
                                    <li>
                                        <span className={classes.notAttempted}/>
                                        <p>{t('not_attempted')}</p>
                                        <h4>{notAnswered}</h4>
                                    </li>
                                    <li>
                                        <span className={classes.skipped}/>
                                        <p>{t('SKIPPED')}</p>
                                        <h4>{notAnsweredVisited}</h4>
                                    </li>
                                    <li>
                                        <span className={classes.reviseLater}/>
                                        <p>{t('REVISE_LATER')}</p>
                                        <h4>{marked}</h4>
                                    </li>
                                </ul>
                            </div>
                            <div className={classes.quizButtonGroups}>
                                <button onClick={() => {
                                    onClose();
                                }}>{t('RESUME')}</button>
                                <button className={classes.finishBtn} onClick={() => {
                                    submitQuiz();
                                    onClose();
                                }}>{t('FINISH')}</button>
                            </div>
                        </div>);

                    }
                });

                // confirmAlert({
                //     title: t("Your quiz is finished"),
                //     message: t("Want to submit your quiz"),
                //     buttons: [
                //         {
                //             label: 'Yes',
                //             onClick: () => {
                //                 submitQuiz()
                //             }
                //         },
                //         {
                //             label: 'No',
                //             onClick: () => {
                //             }
                //         }
                //     ]
                // });
            }
        } else if (type === 'prev') {
            if (activeQuestionIndex > 0) {
                dispatch(setActiveQuestionIndex(activeQuestionIndex - 1));
            }
        }
        saveQuizResponseFn(false);
    }

    //save quiz response fn.
    function saveQuizResponseFn(completed) {
        // No submission in preview mode, view mode or practice mode.
        if (!viewMode && quizMode !== 'preview') {
            dispatch(saveQuizResponse({
                slug: slug,
                quiz: quiz.id,
                response: questions,
                timeTaken: currentRef.current,
                completed: completed
            }));
        }
    }

    return (
        <React.Fragment>{quizIsStarted || viewMode ?
            <div className={"App " + toggleClass}>
                <HeaderSidebar viewMode={viewMode}
                               selectPaletteQuestion={selectPaletteQuestion}
                               drawerToggle={isDrawerClosed}
                               changeSectionActive={changeSectionActive}
                               quizMode={quizMode}
                               quizIsStarted={quizIsStarted}
                               setTimeTaken={setTimeTakenFn}
                               toggleDrawerHandler={toggleDrawerHandler}
                               submitQuiz={submitQuiz}
                               showInstructionBox={showInstructionBox}
                               isLoading={isLoading}
                               isFullscreen={isFullscreen}
                               handleFullScreen={handleFullScreen}
                               pauseQuiz={pauseQuiz}
                               handleQuizPauseChange={handleQuizPauseChange}/>
                <QuestionPlayground mode={quizMode}
                                    viewMode={viewMode}
                                    drawerToggle={isDrawerClosed}
                                    toggleClick={toggleClick}
                                    handleClick={handleClickOnQuestionNavigator}
                                    isLoading={isLoading}
                                    handleQuizPauseChange={handleQuizPauseChange}/>
            </div> : (showInstructionBox && questions && questions.length && questions.length > 0 ?
                <InstructionBlock
                    quiz={quiz}
                    quizIsStarted={quizIsStarted}
                    toggleInstructionBox={toggleInstructionBox}
                    startQuiz={startQuiz}/>
                : '')

        }
            <Modal
               // disableBackdropClick={true}
                disableEscapeKeyDown={true}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={ModelOpen}
                onClose={(event, reason) => {
                    if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        // Set 'open' to false, however you would do that with your particular code.
                      return true;
                    }}
                }
            >
                <div className={classes.quizPauseModel}>
                    <i className="fa fa-clock-o" style={{ fontSize: 80 }}></i>
                    <h2>{t("QUIZ_PAUSED")}</h2>
                    <p>{t("QUIZ_PAUSED_MSG")}</p>
                    <button onClick={() => handleQuizPauseChange(false)} title={t("RESUME_QUIZ")}
                            className={classes.resumeBtn}>
                        <span style={{ fontWeight: 600 }}>{t("RESUME_QUIZ")}</span>
                    </button>

                </div>
            </Modal>
        </React.Fragment>
    );

}

const useStyles = makeStyles(theme => ({
    quizPauseModel: {
        position: 'absolute',
        top: '20%',
        left: '25%',
        width: '60%',
        height: '50%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 5,
        padding: theme.spacing(2, 4, 3),
        color: '#34495E',
        textAlign: 'center',
        paddingTop: '3%',
        '@media (max-width:767px)': {
            top: '17%',
            left: '13%',
            height: '60%'
        }

    },
    resumeBtn: {
        background: '#2962FF',
        cursor: 'pointer',
        padding: 15,
        border: 0,
        marginTop: 10,
        color: '#fff'
    },
    paper: {
        position: 'absolute',
        width: 450,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        boxShadow: 'none',
        boxSizing: 'border-box',
        padding: '20px',
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& img': {
            width: 80,
        },
        '& > h4': {
            fontSize: 17,
            color: '#00BFA5',
            margin: 0,
            marginTop: 20,
            paddingBottom: 10,
        },
        '& > p': {
            fontSize: 13,
            color: '#00BFA5',
            margin: 0,
        },
        '& > h2': {
            textAlign: 'center',
            fontSize: 16,
            color: '#000',
            margin: 0,
            padding: '20px 0 20px'
        },
        '& > span': {
            color: '#000000',
            opacity: 0.4,
            textAlign: 'center',
            fontSize: 13,
            marginBottom: 30,
            fontWeight: 600
        },
        '@media (max-width: 767px)': {
            width: '95%',
        }
    },
    finishModal: {
        zIndex: '9999 !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    attempted: {
        background: '#27AE60',
    },
    reviseLater: {
        background: '#0B2F8A'
    },
    skipped: {
        background: '#FFC658'
    },
    notAttempted: {
        background: '#E1E2E1'
    },
    quizQuestionList: {
        marginBottom: 30,
        '& > ul': {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            '& > li': {
                display: 'flex !important',
                flexWrap: 'wrap',
                justifyContent: 'center',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px #00000021',
                borderRadius: 4,
                alignItems: 'center',
                color: '#000 !important',
                marginBottom: '4% !important',
                minWidth: '48%',
                maxWidth: '48%',
                width: '48%',
                padding: '10px 0px !important',
                boxSizing: 'border-box',
                lineHeight: 'inherit !important',
                '& h4': {
                    width: '100%',
                    margin: 0,
                    fontSize: 18,
                    textAlign: 'center',
                    paddingTop: 10,
                },
                '& span': {
                    width: 12,
                    height: 12,
                    display: 'flex',
                    borderRadius: '50%',
                    marginRight: 8,
                    position: 'relative',
                    top: 0
                },
                '& p': {
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 'bold',
                    opacity: 0.5,
                    color: '#000'
                }
            }
        }
    },
    quizButtonGroups: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 'auto',
        '& button': {
            width: '250px',
            background: '#75757526',
            color: '#000',
            fontSize: 14,
            fontWeight: 'bold',
            padding: '16px 0',
            borderRadius: 4,
            outline: 'none',
            boxShadow: 'none',
            border: 0,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            cursor: 'pointer'
        }
    },
    finishBtn: {
        background: '#00BFA5 !important',
        color: '#fff !important',
        marginTop: 10,
    },
}));

export default QuizPlayground;
